// extracted by mini-css-extract-plugin
export default {"banner-message":"MakeProductAvailable_banner-message__2WM7C","banner-title":"MakeProductAvailable_banner-title__zb3md","link":"MakeProductAvailable_link__3ewyH"};